module.exports = __webpack_public_path__ + "static/media/categories.1fc19405.png";